export const personalDetailsQuestions: Record<string, any> = {
  day: {
    labelKey: 'applicationForm.PERSONAL_DETAILS.dateOfBirth.label',
  },
  month: {
    labelKey: 'applicationForm.PERSONAL_DETAILS.dateOfBirth.label',
  },
  year: {
    labelKey: 'applicationForm.PERSONAL_DETAILS.dateOfBirth.label',
  },
  maritalStatus: {
    labelKey: 'applicationForm.PERSONAL_DETAILS.maritalStatus.label',
    options: [
      { value: 'Single', label: 'Single' },
      { value: 'Married', label: 'Married' },
      { value: 'Divorced', label: 'Divorced' },
      { value: 'Widowed', label: 'Widowed' },
      { value: 'Civil Partnership', label: 'Civil Partnership' },
      { value: 'Separated', label: 'Separated' },
    ],
  },
  retirementAge: {
    labelKey: 'applicationForm.PERSONAL_DETAILS.retirementAge.label',
  },
  firstTimeBuyer: {
    labelKey: 'applicationForm.PERSONAL_DETAILS.firstTimeBuyer.label',
    options: [
      { labelKey: 'common.yes', value: 'YES' },
      { labelKey: 'common.no', value: 'NO' },
    ],
  },
};
